const FAQ_SLICE_TYPE = 'faq';

const isStructuredFaqSlice = slice => slice && slice.slice_type === FAQ_SLICE_TYPE && slice.structured_data_enabled !== false;

const toQuestion = faq => ({
    '@type': 'Question',
    'name': faq.question,
    'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.answer,
    },
});

export const generateFaqStructuredData = bodyItems => {
    const mainEntity = (bodyItems || [])
        .filter(isStructuredFaqSlice)
        .reduce((questions, slice) => questions.concat(slice.items || []), [])
        .filter(faq => faq && faq.question && faq.answer)
        .map(toQuestion);

    if (mainEntity.length === 0) return null;

    return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': mainEntity,
    };
};



// WEBPACK FOOTER //
// ./src/utils/faqStructuredData.js